import React, { memo } from 'react';

import styles from '../PlayIcon.styles.m.css';
import { TPlayIconTheme } from '../PlayIcon.types';

interface IPlayIconRegularProps {
  theme: TPlayIconTheme;
}

export const PlayIconRegular = memo<IPlayIconRegularProps>((props) => {
  const { theme } = props;

  return (
    <>
      <circle
        cx="24"
        cy="24"
        r="20"
        className={styles[`play-icon-bkg-${theme}`]}
      />
    </>
  );
});
